<template>
  <div
      class="tooltip-wrapper"
      @mouseenter="showTooltip"
      @mouseleave="hideTooltip"
      ref="trigger"
  >
    <!-- Slot para o conteúdo que receberá o tooltip -->
    <slot></slot>

    <!-- Tooltip renderizado no body -->
    <transition name="tooltip-fade">
      <div
          v-if="visible && !disabled"
          class="custom-tooltip"
          :style="tooltipStyle"
          ref="tooltip"
      >
        <div class="tooltip-arrow"></div>
        <span class="tooltip-text">{{ text }}</span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'CustomTooltip',

  props: {
    text: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    delay: {
      type: Number,
      default: 80
    }
  },

  data() {
    return {
      visible: false,
      timeoutId: null,
      tooltipStyle: {},
      tooltipElement: null
    };
  },

  methods: {
    showTooltip() {
      if (this.disabled) return;

      this.timeoutId = setTimeout(() => {
        this.visible = true;
        this.$nextTick(() => {
          this.moveTooltipToBody();
          this.calculatePosition();
        });
      }, this.delay);
    },

    hideTooltip() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
      this.visible = false;
      this.removeTooltipFromBody();
    },

    moveTooltipToBody() {
      this.$nextTick(() => {
        const tooltip = this.$refs.tooltip;
        if (tooltip && !this.tooltipElement) {
          document.body.appendChild(tooltip);
          this.tooltipElement = tooltip;
        }
      });
    },

    removeTooltipFromBody() {
      if (this.tooltipElement && this.tooltipElement.parentNode === document.body) {
        document.body.removeChild(this.tooltipElement);
        this.tooltipElement = null;
      }
    },

    calculatePosition() {
      const trigger = this.$refs.trigger;

      if (!trigger) return;

      const triggerRect = trigger.getBoundingClientRect();

      // Posiciona à direita do elemento
      this.tooltipStyle = {
        left: `${triggerRect.right + 12}px`,
        top: `${triggerRect.top + (triggerRect.height / 2)}px`,
        transform: 'translateY(-50%)'
      };
    }
  },

  beforeDestroy() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.removeTooltipFromBody();
  }
};
</script>

<style>
.tooltip-wrapper {
  position: relative;
  display: block;
  width: 100%;
}

.custom-tooltip {
  position: fixed;
  z-index: 9999;
  pointer-events: none;
  white-space: nowrap;
}

.tooltip-text {
  display: inline-block;
  background: #023449;
  color: white;
  padding: 10px 18px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.15);
  letter-spacing: 0.3px;
}

/* Seta do tooltip */
.tooltip-arrow {
  position: absolute;
  left: -5px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid #023449;
  z-index: 1;
}

/* Animação de fade */
.tooltip-fade-enter-active,
.tooltip-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.tooltip-fade-enter,
.tooltip-fade-leave-to {
  opacity: 0;
  transform: translateY(-50%) translateX(-8px);
}

.tooltip-fade-enter-to,
.tooltip-fade-leave {
  opacity: 1;
  transform: translateY(-50%) translateX(0);
}
</style>